import { cn } from '@/lib/utils';
import type { ConnectionStatus } from '@fabricos/protocol-ts';

const colors: Record<ConnectionStatus, string> = {
  connected: 'bg-status-good shadow-status-good/50',
  connecting: 'bg-status-warn animate-pulse',
  degraded: 'bg-status-warn',
  lost: 'bg-status-critical animate-pulse',
  disconnected: 'bg-status-offline',
};

export function StatusDot({ status, className }: { status: ConnectionStatus; className?: string }) {
  return (
    <span
      className={cn(
        'inline-block h-2 w-2 rounded-full shadow-[0_0_4px_currentColor]',
        colors[status] ?? colors.disconnected,
        className,
      )}
      aria-label={status}
    />
  );
}
